import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const FireIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M8.75.746c0-.744-.958-1.024-1.38-.408C3.5 5.995 9 6.25 9 9a2 2 0 0 1-2.027 2C5.874 10.986 5 10.07 5 8.97V6.298c0-.678-.827-1.007-1.295-.515C2.87 6.66 2 8.167 2 10c0 3.309 2.692 6 6 6s6-2.691 6-6C14 4.678 8.75 3.969 8.75.746Z", fill: "currentColor" })));
});
FireIcon.displayName = 'FireIcon';
export default FireIcon;
